import { useEffect, useState } from "react"

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

function convertIPToNumber(ip: string): number {
  const parts = ip.trim().split(".")
  if (parts.length !== 4) return -1
  let result = 0
  for (const part of parts) {
    const n = parseInt(part.trim(), 10)
    if (isNaN(n)) return -2
    result = result * 256 + (n % 256)
  }
  return result
}

const css = `
  * { box-sizing: border-box; }
  body { font-family: 'Trebuchet MS', sans-serif; font-size: 10pt; margin: 0; background: #fff; }

  .cssLabelMandatory {
    background-color: #000080; color: White; height: 22px;
    font-size: 9pt; font-family: 'Trebuchet MS'; padding-left: 7px;
    display: flex; align-items: center;
  }
  .cssTextBox {
    font-family: 'Trebuchet MS'; font-size: 11pt;
    border: solid 1px #006600; padding-left: 5px;
    height: 24px; width: 97%;
  }
  .cssTextBoxReadOnly {
    font-family: 'Trebuchet MS'; font-size: 11pt;
    border: solid 1px gray; padding-left: 5px;
    height: 24px; width: 97%; background-color: #EEEEEE;
  }
  .cssButton {
    background-color: #119ECC; font-family: 'Trebuchet MS'; font-size: 8pt;
    color: White; border: none; height: 24px; width: 60px; cursor: pointer;
  }
`

export default function EL_SchoolIPs() {
  const params   = new URLSearchParams(window.location.search)
  const ipId     = params.get("IPID") ?? ""
  const schoolCode = params.get("SchoolCode") ?? ""

  const caption  = ipId ? "Modifying" : "Adding"

  const [startIP, setStartIP] = useState("")
  const [endIP,   setEndIP]   = useState("")
  const [alertMsg, setAlertMsg] = useState("")
  const [errorMsg, setErrorMsg] = useState("")

  useEffect(() => {
    if (!ipId) return
    fetch(`${API_BASE_URL}api/school-ip/${ipId}/`)
      .then(r => r.json())
      .then(data => {
        setStartIP(data.start_ip_address ?? "")
        setEndIP(data.end_ip_address   ?? "")
      })
      .catch(() => setErrorMsg("Failed to load IP record."))
  }, [ipId])

  async function handleSave() {
    setAlertMsg("")
    setErrorMsg("")

    const startNum = convertIPToNumber(startIP)
    const endNum   = convertIPToNumber(endIP)

    if (startNum < 0 || endNum < 0 || endNum < startNum) {
      setAlertMsg("Incorrect IP Address Range.")
      return
    }

    try {
      const res = await fetch(`${API_BASE_URL}api/save-ip/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ip_id:             ipId || null,
          school_code:       schoolCode,
          start_ip_address:  startIP.trim(),
          end_ip_address:    endIP.trim(),
          start_ip_number:   startNum,
          end_ip_number:     endNum
        })
      })

      const data = await res.json()

      if (data.clash) {
        setAlertMsg(`The IP Address Range clashes with range given for SchoolCode  ${data.clash_school_code}`)
        return
      }

      if (!res.ok) throw new Error()

      setStartIP("")
      setEndIP("")
      handleCancel()

    } catch {
      setErrorMsg("Save failed. Please try again.")
    }
  }


  function handleCancel() {
    window.location.href = `/WebAdmin/SCHOOLS/EL_SchoolDetails?SchoolCode=${schoolCode}`
  }

  return (
    <>
      <style>{css}</style>

      <br /><br /><br /><br />

      <table
        align="center" cellPadding={0} cellSpacing={1}
        style={{ width: "35%", border: "solid 1px blue", borderCollapse: "collapse" }}
      >
 
        <tbody>
          <tr style={{ height: 50 }}>
            <td
              colSpan={2} align="center" valign="middle"
              style={{
                fontFamily: "Trebuchet MS", color: "#3264a0",
                fontWeight: "bold", fontSize: "12pt", height: 50
              }}
            >
              {caption} of IP Address range for School
            </td>
          </tr>

          {alertMsg && (
            <tr>
              <td colSpan={2} style={{ color: "red", fontFamily: "Trebuchet MS", fontSize: "9pt", padding: "4px 8px" }}>
                {alertMsg}
              </td>
            </tr>
          )}
          {errorMsg && (
            <tr>
              <td colSpan={2} style={{ color: "darkred", fontFamily: "Trebuchet MS", fontSize: "9pt", padding: "4px 8px" }}>
                {errorMsg}
              </td>
            </tr>
          )}

          <tr>
            <td className="cssLabelMandatory" style={{ width: "100%" }}>SchoolCode</td>
            <td style={{ width: "60%", padding: "2px 4px" }}>
              <input className="cssTextBoxReadOnly" value={schoolCode} readOnly />
            </td>
          </tr>

          <tr>
            <td className="cssLabelMandatory">Start IP</td>
            <td style={{ padding: "2px 4px" }}>
              <input
                className="cssTextBox"
                value={startIP}
                maxLength={20}
                onChange={e => setStartIP(e.target.value)}
              />
            </td>
          </tr>

          <tr>
            <td className="cssLabelMandatory">End IP</td>
            <td style={{ padding: "2px 4px" }}>
              <input
                className="cssTextBox"
                value={endIP}
                maxLength={20}
                onChange={e => setEndIP(e.target.value)}
              />
            </td>
          </tr>

          <tr style={{ height: 50 }}>
            <td colSpan={2} align="center" valign="middle" style={{ height: 50 }}>
              <button className="cssButton" onClick={handleSave}>Save</button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button className="cssButton" onClick={handleCancel}>Cancel</button>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}